declare global {
  interface CommonConfig {
    brand: 'wix' | 'editorx' | 'studio'
    host:
      | 'STUDIO'
      | 'MOBILE_APP_BUILDER'
      | 'EDITOR_X'
      | 'EDITOR'
      | 'VIEWER'
      | 'BLOCKS'
    branchId?: string
  }

  interface Window {
    commonConfig: CommonConfig
  }

  interface self {
    commonConfig: CommonConfig
  }
}

// Deprecated. Use utils from https://github.com/wix-private/wix-data-client/blob/master/common/src/infra/editorType.ts instead.
export const isWixStudio = (): boolean => {
  try {
    return window.commonConfig?.brand === 'studio'
  } catch {
    return self.commonConfig?.brand === 'studio'
  }
}

export const isMobileAppEditor = (): boolean => {
  try {
    return window.commonConfig?.host === 'MOBILE_APP_BUILDER'
  } catch {
    return self.commonConfig?.host === 'MOBILE_APP_BUILDER'
  }
}
